/**
 * @generated SignedSource<<7d1cf693bab9584542567abe8891c3e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ShortcutsTab_tab$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_tab">;
  readonly " $fragmentType": "ShortcutsTab_tab";
};
export type ShortcutsTab_tab$key = {
  readonly " $data"?: ShortcutsTab_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShortcutsTab_tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ShortcutsTab_tab",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_tab"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "44ec907f13fc9eea05e67f5b8c1abeae";

export default node;
